var jquery = require("jquery");
window.$ = window.jQuery = jquery;
var visible = require("jquery-visible");
var cookie = require("jquery.cookie");
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;

require("@fancyapps/fancybox");
import Swiper from 'swiper/bundle';

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();


if ($('.home-slider').length) {
	var sliderHome = new Swiper('.home-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		autoResize: true,
		autoHeight: true,
		speed: 500,
		effect: "creative",
		creativeEffect: {
			prev: {
				shadow: false,
				translate: ["-20%", 0, -1],
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		autoplay: {
			delay: 3000,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: $('.home-slider').find('.swiper-button-next')[0],
			prevEl: $('.home-slider').find('.swiper-button-prev')[0],
		},
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper'
	});
}


if ($('.list-slider').length) {
	const swiperList = new Swiper('.list-slider', {
		slidesPerView: 1,
		effect: 'fade',
		fadeEffect: {
		  crossFade: true
		},
		spaceBetween: 0,
		autoResize: true,
		autoHeight: true,
		loop: false,
		navigation: false,
		speed: 1000,
		normalizeSlideIndex: true,
		snapOnRelease: true,
		scrollbar: false,
		autoplay: false,
        breakpoints: {
            1920: {
                autoHeight: false,
				autoplay: {
					delay: 2000,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
					stopOnLastSlide: true,
				},
            },
        },
	}).on('beforeInit', function() {
		swiperList.autoplay.stop();
	}).on('slideChangeTransitionStart', function() {
		var gotoIndex = swiperList.realIndex;
		var gotoEl = $('.sliding-list-section [data-slide-go-to='+gotoIndex+']');
		$('.sliding-list-section [data-slide-go-to]').not(gotoEl).attr('aria-expanded', false);
		gotoEl.attr('aria-expanded', true);
	});

	$('.sliding-list-section .slide-go-to').on("click", function(e) {
		swiperList.slideTo($(this).data('slide-go-to'));
		if ($(window).width() >= 1920) {
			swiperList.autoplay.stop();
		}
	});
	$('.sliding-list-section .slide-go-to').on("mouseover", function(e) {
		if ($(window).width() >= 1920) {
			swiperList.slideTo($(this).data('slide-go-to'));
			swiperList.autoplay.stop();
		}
	});
	$('.sliding-list-section .slide-go-to').on("focus", function(e) {
		swiperList.slideTo($(this).data('slide-go-to'));
		if ($(window).width() >= 1920) {
			swiperList.autoplay.stop();
		}
	});
	$('.sliding-list-section .slide-go-to').on("mouseout", function(e) {
		if ($(window).width() >= 1920) {
			swiperList.autoplay.start();
		}
	});
}


if ($('.testimonials-slider').length) {
	const swiperTestimonials = new Swiper('.testimonials-slider', {
		slidesPerView: 1,
		spaceBetween: 20,
		effect: 'fade',
		fadeEffect: {
		  crossFade: true
		},
		autoResize: true,
		autoHeight: true,
		loop: false,
		navigation: false,
		speed: 1000,
		normalizeSlideIndex: true,
		snapOnRelease: true,
		scrollbar: false,
		autoplay: false,
        breakpoints: {
            1280: {

            },
        },
	}).on('beforeInit', function() {
		swiperTestimonials.autoplay.stop();
	}).on('slideChangeTransitionStart', function() {
		var gotoIndex = swiperTestimonials.realIndex;
		var gotoEl = $('.testimonials-slider-section [data-slide-go-to='+gotoIndex+']');
		$('.testimonials-slider-section [data-slide-go-to]').not(gotoEl).attr('aria-expanded', false);
		gotoEl.attr('aria-expanded', true);
	});

	$('.testimonials-slider-section .slide-go-to').on("click", function(e) {
		swiperTestimonials.slideTo($(this).data('slide-go-to'));
	});
	$('.testimonials-slider-section .slide-go-to').on("focus", function(e) {
		swiperTestimonials.slideTo($(this).data('slide-go-to'));
	});
}

var sliderComp = Swiper;
if ($('.component-slider').length) {
	$('.component-slider').each(function(i) {
		var el = $(this);
		sliderComp = new Swiper($(this)[0], {
			slidesPerView: 1,
			spaceBetween: 16,
			autoResize: true,
			speed: 500,
			navigation: {
				nextEl: el.closest('.slider-section').find('.component-slider-next')[0],
				prevEl: el.closest('.slider-section').find('.component-slider-prev')[0],
			},
			scrollbar: false,
			pagination: false,
			loop: false,
			touchEventsTarget: 'wrapper',
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1280: {
					slidesPerView: 3,
				},
			},
		});
	});
}


if ($('.component-slider-teams').length) {
	var sliderCompTeams = new Swiper('.component-slider-teams', {
		slidesPerView: 1,
		spaceBetween: 16,
		autoResize: true,
		speed: 500,
		navigation: {
			nextEl: $('.component-slider-teams-next')[0],
			prevEl: $('.component-slider-teams-prev')[0],
		},
		scrollbar: false,
		pagination: false,
		loop: false,
		touchEventsTarget: 'wrapper',
        breakpoints: {
            768: {
				slidesPerView: 2,
            },
            1280: {
				slidesPerView: 3,
            },
        },
	});
}


// READY

$(function () {
	console.log('Website proudly by Imagic Creative');

	announcement();

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		} else if ($(window).scrollTop() < 5) {
			$('header').removeClass('nav-up').removeClass('nav-down');
		}
	}, 250);

	contentBlocksMenu();
	manualBlocksMenu();

	if ($('.menu-main a.active-parent').length) {
		var activeParent = $('.menu-main a.active-parent');
		activeParent.each(function() {
			$(this).parent().addClass('active');
		});
	}
	if ($('.menu-main a.active-child').length) {
		$('.menu-main a.active-child').parent().parent().parent().addClass('active');
	}
	if ($('.menu-main-mobile a.active-parent').length) {
		$('.menu-main-mobile a.active-parent').parent().not('.open').find('button').trigger('click');
	}
	if ($('.menu-main-mobile a.active-child').length) {
		$('.menu-main-mobile a.active-child').parent().parent().parent().not('.open').find('button').trigger('click');
	}

	voteForm();

});


// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

	contentBlocksMenu();
	manualBlocksMenu();

	

});



// RESIZE

$(window).on('resize', function() {

	voteForm();

	announcement();

});




$(".menu-main .with-menu-sub").on("mouseenter", function (e) {
	e.stopPropagation();
	$(this).addClass('with-menu-sub-hover');
	$(this).find('button').attr('aria-expanded', true);
	$(this).find('ul').attr('aria-hidden', false);
	$(this).find('ul').fadeIn(300);
});
$(".menu-main .with-menu-sub").on("mouseleave", function (e) {
	e.stopPropagation();
	$(this).removeClass('with-menu-sub-hover');
	$(this).find('button').attr('aria-expanded', false);
	$(this).find('ul').attr('aria-hidden', true);
	$(this).find('ul').fadeOut(300);
});
$(document).on('click', '.menu-main .with-menu-sub > button[aria-expanded="false"]', function(e) {
	e.stopPropagation();
	$(this).parent().addClass('with-menu-sub-hover');
	$(this).parent().find('button').attr('aria-expanded', true);
	$(this).parent().find('ul').attr('aria-hidden', false);
	$(this).parent().find('ul').fadeIn(300);
});
$(document).on('click', '.menu-main .with-menu-sub > button[aria-expanded="true"]', function(e) {
	e.stopPropagation();
	$('.menu-main .with-menu-sub').removeClass('with-menu-sub-hover');
	$(this).parent().find('button').attr('aria-expanded', false);
	$(this).parent().find('ul').attr('aria-hidden', true);
	$(this).parent().find('ul').fadeOut(300);
});



function hasScrolled() {
	if (($('body.specialists').length || $('body.news-page').length || $('body.search').length) && $(window).width() >= 1024 ) {
		return;
	}
	// if (($('.section-product-detail').length || $('.section-stores').length) && $(window).width() >= 1024) {
	// 	$('header').removeClass('nav-up').addClass('nav-down');
	// 	return;
	// }
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
		var topOffset = 5;
		if ($(window).width() >= 1280) {
			topOffset = topOffset + $('.announcement-section[data-view="desktop"]').outerHeight();
		}

        if(st < topOffset) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }
    
    lastScrollTop = st;
} 

$('.hamburger').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-menu-open');
	$('.section-drawer-mobile .toggle-drawer').removeClass('open');
	$('.headerContainer').add('body').removeClass('mobile-drawer-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
		console.log('here 1');
	}
	$('header .section-drawer-mobile').scrollTop(0);
	if ($(this).hasClass('open')) {
		$(this).attr('aria-expanded', true);
		$('.menu-main-mobile-container').attr('aria-hidden', false);
		$('.section-drawer-mobile .toggle-drawer').attr('aria-expanded', false);
		$('.drawer-content').attr('aria-hidden', true);
	} else {
		$(this).attr('aria-expanded', false);
		$('.menu-main-mobile-container').attr('aria-hidden', true);
	}
});

$(document).on('click', '.menu-main-mobile li.with-menu-sub button', function(e) {
	e.stopPropagation();
	$(this).parent().toggleClass('open');
	if ($(this).parent().hasClass('open')) {
		$(this).parent().find('.menu-sub').attr('aria-hidden', false);
		$(this).parent().find('.menu-sub').slideDown(400);
	} else {
		$(this).parent().find('.menu-sub').attr('aria-hidden', true);
		$(this).parent().find('.menu-sub').slideUp(400);
	}
});

$(document).on('click', '.section-drawer-mobile .toggle-drawer', function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-drawer-open');
	$('.hamburger').removeClass('open');
	$('.headerContainer').add('body').removeClass('mobile-menu-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	$('header .section-menu-mobile').scrollTop(0);
	if ($(this).hasClass('open')) {
		$(this).attr('aria-expanded', true);
		$('.drawer-content').attr('aria-hidden', false);
	} else {
		$(this).attr('aria-expanded', false);
		$('.drawer-content').attr('aria-hidden', true);
	}
});

$(document).on('click', 'body.mobile-drawer-open .backdrop', function(e) {
	e.stopPropagation();
	$('.section-drawer-mobile .toggle-drawer').removeClass('open');
	$('.headerContainer').add('body').removeClass('mobile-drawer-open');
	$('.section-drawer-mobile .toggle-drawer').attr('aria-expanded', false);
	$('.drawer-content').attr('aria-hidden', true);
});

$(document).on('click', 'body.mobile-menu-open .backdrop', function(e) {
	e.stopPropagation();
	$('.hamburger').trigger('click');
});





// ACCORDION


$(document).on('click', '.accordion:not(.is-open)', function(e) {
	$(this).addClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	var maxH = content.find('div').outerHeight() + 40;
	content.css('max-height', maxH);
});
$(document).on('click', '.accordion.is-open', function(e) {
	$(this).removeClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	content.removeAttr('style');
});
$(document).on('click', '.open-all', function(e) {
	$('.accordion').each(function() {
		$(this).addClass('is-open');
		var content = $(this).parent().find('.accordion-content');
		var maxH = content.find('div').outerHeight() + 40;
		content.css('max-height', maxH);
	});
});
$(document).on('click', '.close-all', function(e) {
	$('.accordion').removeClass('is-open');
	var content = $('.accordion-content');
	content.removeAttr('style');
});





// FILTERS and SEARCH
$(document).on('click', '#load-more-btn', function(e) {
	$(this).find('.loader').removeClass('hidden').addClass('block');
});
$(document).on('click', '#search-btn', function(e) {
	$(this).find('.loader').removeClass('hidden').addClass('block');
});
$(document).on('change', '.dropdown-filter select', function(e) {
	$(this).parent().find('.loader').removeClass('hidden').addClass('block');
	// $('.entry-search-form input[name="query"]').val('');
});
$(document).on('click', '.clear-search', function(e) {
	$(this).parent().find('input').val('');
	$('#search-btn').trigger('click');
});
$(document).on('click', 'body:not(.search) .toggle-search:not(.open)', function(e) {
	$(this).addClass('open');
	$('header form.entry-search-form').addClass('open');
	$('header form.entry-search-form input').trigger('focus');
});
$(document).on('click', 'body:not(.search) .toggle-search.open', function(e) {
	$(this).removeClass('open');
	$('header form.entry-search-form').removeClass('open');
});
$(document).on('click', 'body.search .toggle-search', function(e) {
	$('html, body').animate({
		scrollTop: $("#sprigSearch").offset().top
	}, 500);
});



// CONTENT BLOCKS JUMP TO
function contentBlocksMenu() {
	if ($('.content-blocks-section[data-view="with-menu"]').length) {
		var links = $('.content-blocks-section[data-view="with-menu"] a');
		links.each(function() {
			var blockId = $(this).attr('href').replace('#','');
			var block = $('.content-block[id="' + blockId + '"]');
			var children = block.children();
			var childrenVis = false;
			children.each(function() {
				if ($(this).visible(true)) {
					childrenVis = true;
				}
			});
			if (block.visible(true) || childrenVis ) {
				$(this).addClass('active');
			} else {
				$(this).removeClass('active');
			}
		});
	}
}
function manualBlocksMenu() {
	if ($('.manual-section').length) {
		var links = $('.manual-section a');
		links.each(function() {
			var blockId = $(this).attr('href').replace('#','');
			var block = $('.content-block[id="' + blockId + '"]');
			var children = block.children();
			var childrenVis = false;
			children.each(function() {
				if ($(this).visible(true)) {
					childrenVis = true;
				}
			});
			if (block.visible(true) || childrenVis ) {
				$(this).addClass('active');
			} else {
				$(this).removeClass('active');
			}
		});
	}
}




// VOTE

$(document).on('click', '#vote-yes button', function(e) {
	e.stopPropagation();
	$('#vote-no').hide();
});
$(document).on('click', '#vote-no button', function(e) {
	e.stopPropagation();
	$('#vote-yes').hide();
});
$(document).on('click', '.problem-form-toggle:not(.open)', function(e) {
	e.stopPropagation();
	$(this).addClass('open');
	$('.vote-section .row-form').slideDown();
});
$(document).on('click', '.problem-form-toggle.open', function(e) {
	e.stopPropagation();
	$(this).removeClass('open');
	$('.vote-section .row-form').slideUp();
});

function voteForm() {
	var btn = $('.vote-section .problem-form-toggle');
	if (btn.length) {
		var btnLeft = btn.offset().left;
		var parentLeft = btn.parent().offset().left;
		var margin = btnLeft - parentLeft - 8;
		$('.vote-section .column-form').css('margin-left', margin);
	}
}

htmx.on('htmx:afterSwap', function(event) {
    if (event.target.id == 'vote') {
        voteForm();
		$("[data-required]").each(function (index) {
			$(this).attr('required', true);
		});
    }
});





// ANNOUNCEMENT

function announcement() {
	if ($(window).width() >= 1280) {
		$('.announcement-section[data-view="mobile"]').slideUp();
		if ($.cookie('announcement-hide')) {
			$('.announcement-section[data-view="desktop"]').slideUp();
		} else {
			$('.announcement-section[data-view="desktop"]').slideDown();
		}
	} else {
		$('.announcement-section[data-view="desktop"]').slideUp();
		if ($.cookie('announcement-hide')) {
			$('.announcement-section[data-view="mobile"]').slideUp();
		} else {
			$('.announcement-section[data-view="mobile"]').slideDown();
		}
	}
}

$(document).on('click', '.announcement-cancel', function(e) {
	$.cookie('announcement-hide', true);
	$('.announcement-section').slideUp();
	console.log($.cookie('announcement-hide'));
});



//vote yes or no
const myFormY = document.getElementById("vote-yes");
myFormY.addEventListener("freeform-ajax-success", function (event) {
	$('#vote-yes .freeform-button-container').hide();
});
myFormY.addEventListener("freeform-ajax-error", function (event) {
	$('#vote-no').show();
});

const myFormN = document.getElementById("vote-no");
myFormN.addEventListener("freeform-ajax-success", function (event) {
	$('#vote-no .freeform-button-container').hide();
});
myFormN.addEventListener("freeform-ajax-error", function (event) {
	$('#vote-yes').show();
});